module.exports = __webpack_public_path__ + "static/media/dropdown.88c5b37f.svg";